
// 
// function test (list, value, key, children = 'children') {
//   const arr = []
//   const tree = {
//     [key]: -1,
//     children: list[children]
//   }

//   one(tree, children, arr)
// }



// function one (tree, value, key, children, arr) {
//   if (tree[children] && tree[children].length) {
//     tree[children].forEach(item => {
//       if (item[key] === value) {
//         arr.push()
//       }
//       if (item[children] && item[children].length) {

//       } else {

//       }
//     })
//   }
//   return arr
// }

// function _one (tree, arr) {

// }

function findTrackById (list, value, key, children) {
  const tracks = findTracks(list, key, children) || []
  if (tracks.length === 0 || !value) {
    return []
  }
  const track = tracks.filter(item => item.includes(value))[0] || ''
  return track.split('/') || []
}

function findTracks (list, key, children = 'children') {
  const arr = []
  
  if (list && list.length) {
    _findTracks(list,key,children, arr, '')
  }
  return arr
}

function _findTracks (list, key, children = '', arr, parent = '') {
  if (list && list.length) {
    list.forEach(item => {
      if (item[children] && item[children].length) {
        let oldParent = parent
        parent = parent ? `${parent}/${item[key]}` : `${item[key]}`
        _findTracks(item[children], key, children = 'children', arr, parent)
        parent = oldParent
      } else {
        const idTrack = parent ? `${parent}/${item[key]}` : `${item[key]}`
        arr.push(idTrack)
      }
    })
  }
}

export {
  findTrackById,
  findTracks
}